import { Link, useNavigate } from "react-router-dom";
import { LogOut, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../auth/AuthContext";

export const PageShell = ({ title, subtitle, children }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success("Signed out. See you on the road!");
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-xl border-b border-slate-200/70">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3" data-testid="shell-brand-link">
            <img src="/logo.png" alt="Voyage Switzerland" className="h-11 w-auto" />
          </Link>
          <div className="flex items-center gap-3">
            <Link
              to="/"
              data-testid="shell-back-to-site-link"
              className="inline-flex items-center gap-1.5 text-sm font-bold text-slate-600 hover:text-[var(--brand)] transition-colors"
            >
              <ArrowLeft className="w-4 h-4" /> Back to site
            </Link>
            {user && (
              <>
                <span className="hidden md:inline-flex items-center rounded-full bg-[var(--brand-soft)] px-4 py-1.5 text-xs font-bold text-[var(--brand)]" data-testid="shell-user-chip">
                  {user.name} · {user.role}
                </span>
                <button
                  data-testid="shell-logout-button"
                  onClick={handleLogout}
                  className="w-9 h-9 rounded-full border border-slate-200 flex items-center justify-center text-slate-500 hover:text-red-500 hover:border-red-200 transition-colors"
                  aria-label="Sign out"
                >
                  <LogOut className="w-4 h-4" />
                </button>
              </>
            )}
          </div>
        </div>
      </header>
      <main className="max-w-7xl mx-auto px-5 sm:px-8 py-10 sm:py-14">
        {title && (
          <div className="mb-8">
            <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl text-[#0b132b]" data-testid="shell-title">
              {title}
            </h1>
            {subtitle && <p className="mt-2 text-sm sm:text-base text-slate-500 font-medium">{subtitle}</p>}
          </div>
        )}
        {children}
      </main>
    </div>
  );
};
